module.exports = __webpack_public_path__ + "static/media/thumb_up.23206796.svg";